import {AccountCheckConfig} from '@/app/account/shared/config/account-check.config';
import {Enum}               from '@/app/shared/enum/enum';
import {Message}            from '@/app/shared/model/message.model';
import {Check}              from '@/app/account/shared/model/check.model';

export default class CheckService {
  isPc(joinCode: Enum.ACCOUNT.CHECK.JOIN_CODE): boolean {
    let returnValue: boolean = false;

    if (AccountCheckConfig.IS_PC.indexOf(joinCode) >= 0) {
      returnValue = true;
    }

    return returnValue;
  }

  isMobile(joinCode: Enum.ACCOUNT.CHECK.JOIN_CODE): boolean {
    let returnValue: boolean = false;

    if (AccountCheckConfig.IS_MOBILE.indexOf(joinCode) >= 0) {
      returnValue = true;
    }

    return returnValue;
  }

  isApp(joinCode: Enum.ACCOUNT.CHECK.JOIN_CODE): boolean {
    let returnValue: boolean = false;

    if (AccountCheckConfig.IS_APP.indexOf(joinCode) >= 0) {
      returnValue = true;
    }

    return returnValue;
  }

  isDefault(joinCode: Enum.ACCOUNT.CHECK.JOIN_CODE): boolean {
    let returnValue: boolean = false;

    if (AccountCheckConfig.IS_DEFAULT.indexOf(joinCode) >= 0) {
      returnValue = true;
    }

    return returnValue;
  }

  isSns(joinCode: Enum.ACCOUNT.CHECK.JOIN_CODE): boolean {
    let returnValue: boolean = false;

    if (AccountCheckConfig.IS_SNS.indexOf(joinCode) >= 0) {
      returnValue = true;
    }

    return returnValue;
  }

  isApple(joinCode: Enum.ACCOUNT.CHECK.JOIN_CODE): boolean {
    let returnValue: boolean = false;

    if (AccountCheckConfig.IS_APPLE.indexOf(joinCode) >= 0) {
      returnValue = true;
    }

    return returnValue;
  }

  isCtn(joinCode: Enum.ACCOUNT.CHECK.JOIN_CODE): boolean {
    let returnValue: boolean = false;

    if (AccountCheckConfig.IS_CTN.indexOf(joinCode) >= 0) {
      returnValue = true;
    }

    return returnValue;
  }

  isGiga(joinCode: Enum.ACCOUNT.CHECK.JOIN_CODE): boolean {
    let returnValue: boolean = false;

    if (AccountCheckConfig.IS_GIGA.indexOf(joinCode) >= 0) {
      returnValue = true;
    }

    return returnValue;
  }

  isHomeBoy(joinCode: Enum.ACCOUNT.CHECK.JOIN_CODE): boolean {
    let returnValue: boolean = false;

    if (AccountCheckConfig.IS_HOME_BOY.indexOf(joinCode) >= 0) {
      returnValue = true;
    }

    return returnValue;
  }

  isOpenApi(joinCode: Enum.ACCOUNT.CHECK.JOIN_CODE): boolean {
    let returnValue: boolean = false;

    if (AccountCheckConfig.IS_OPEN_API.indexOf(joinCode) >= 0) {
      returnValue = true;
    }

    return returnValue;
  }

  isCodeValid(code: Check.Response.CodeToEnum): boolean {
    let returnValue: boolean = false;

    if (!!code) {
      if (!!code.joinCode) {
        if (this.isDefault(code.joinCode)) {
          returnValue = true;
        } else if (this.isCtn(code.joinCode)) {
          if (!!code.ctn && !!code.ctn.param) {
            returnValue = true;
          }
        } else if (this.isSns(code.joinCode)) {
          if (!!code.token) {
            returnValue = true;
          }
        }
      }
    }

    return returnValue;
  }

  isCodeChecker(code: Check.Response.CodeToEnum) {
    let returnValue: boolean = true;

    if (!this.isCodeValid(code)) {
      window.alert(Message.ALERT.ACCESS_DENIED);
      window.history.back();
      returnValue = false;
    }

    return returnValue;
  }

  isMobileWidth(): boolean {
    let returnValue: boolean = false;

    if (window.innerWidth <= 1024) {
      returnValue = true;
    }

    return returnValue;
  }

  getAuthLink(authUrlType: Enum.ACCOUNT.CHECK.ACTION_TYPE, joinCode: Enum.ACCOUNT.CHECK.JOIN_CODE): string {
    let returnValue: string = '';
    const check = this.getAuthCheck();
    const targetType: Enum.ACCOUNT.CHECK.TARGET_TYPE | null = this.getTargetType(joinCode);

    if (!!targetType) {
      returnValue = check[targetType][authUrlType];
    }

    return returnValue;
  }

  private getTargetType(joinCode: Enum.ACCOUNT.CHECK.JOIN_CODE): Enum.ACCOUNT.CHECK.TARGET_TYPE | null {
    let returnValue: Enum.ACCOUNT.CHECK.TARGET_TYPE | null = null;

    if (this.isPc(joinCode)) {
      returnValue = Enum.ACCOUNT.CHECK.TARGET_TYPE.PC;
    } else if (this.isMobile(joinCode)) {
      if (this.isOpenApi(joinCode)) {
        returnValue = Enum.ACCOUNT.CHECK.TARGET_TYPE.OPEN_API;
      } else {
        returnValue = Enum.ACCOUNT.CHECK.TARGET_TYPE.MOBILE;
      }
    } else if (this.isApp(joinCode)) {
      if (this.isCtn(joinCode)) {
        if (this.isGiga(joinCode)) {
          returnValue = Enum.ACCOUNT.CHECK.TARGET_TYPE.GIGA_CTN;
        } else {
          returnValue = Enum.ACCOUNT.CHECK.TARGET_TYPE.CTN;
        }
      } else if (this.isGiga(joinCode)) {
        returnValue = Enum.ACCOUNT.CHECK.TARGET_TYPE.GIGA;
      } else if (this.isOpenApi(joinCode)) {
          returnValue = Enum.ACCOUNT.CHECK.TARGET_TYPE.OPEN_API;
      } else {
        returnValue = Enum.ACCOUNT.CHECK.TARGET_TYPE.APP;
      }
    }

    return returnValue;
  }

  private getAuthCheck() {
    const check = {};

    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.PC] = {};
    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.MOBILE] = {};
    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.APP] = {};
    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.CTN] = {};
    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.GIGA] = {};
    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.GIGA_CTN] = {};
    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.OPEN_API] = {};

    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.PC][Enum.ACCOUNT.CHECK.ACTION_TYPE.CREATE] = `${process.env.VUE_APP_GENIE_PC_WEB_DOMAIN}${process.env.VUE_APP_GENIE_PC_WEB_CREATE}`;
    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.PC][Enum.ACCOUNT.CHECK.ACTION_TYPE.FIND_ID] = `${process.env.VUE_APP_GENIE_PC_WEB_DOMAIN}${process.env.VUE_APP_GENIE_PC_WEB_FIND_ID}`;
    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.PC][Enum.ACCOUNT.CHECK.ACTION_TYPE.FIND_PW] = `${process.env.VUE_APP_GENIE_PC_WEB_DOMAIN}${process.env.VUE_APP_GENIE_PC_WEB_FIND_PW}`;

    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.MOBILE][Enum.ACCOUNT.CHECK.ACTION_TYPE.CREATE] = `${process.env.VUE_APP_GENIE_MOBILE_WEB_DOMAIN}${process.env.VUE_APP_GENIE_MOBILE_WEB_CREATE}`;
    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.MOBILE][Enum.ACCOUNT.CHECK.ACTION_TYPE.FIND_ID] = `${process.env.VUE_APP_GENIE_MOBILE_WEB_DOMAIN}${process.env.VUE_APP_GENIE_MOBILE_WEB_FIND_ID}`;
    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.MOBILE][Enum.ACCOUNT.CHECK.ACTION_TYPE.FIND_PW] = `${process.env.VUE_APP_GENIE_MOBILE_WEB_DOMAIN}${process.env.VUE_APP_GENIE_MOBILE_WEB_FIND_PW}`;

    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.APP][Enum.ACCOUNT.CHECK.ACTION_TYPE.CREATE] = `${process.env.VUE_APP_GENIE_APP_DOMAIN}${process.env.VUE_APP_GENIE_APP_CREATE}`;
    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.APP][Enum.ACCOUNT.CHECK.ACTION_TYPE.FIND_ID] = `${process.env.VUE_APP_GENIE_APP_DOMAIN}${process.env.VUE_APP_GENIE_APP_FIND_ID}`;
    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.APP][Enum.ACCOUNT.CHECK.ACTION_TYPE.FIND_PW] = `${process.env.VUE_APP_GENIE_APP_DOMAIN}${process.env.VUE_APP_GENIE_APP_FIND_PW}`;

    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.CTN][Enum.ACCOUNT.CHECK.ACTION_TYPE.CREATE] = `${process.env.VUE_APP_GENIE_CTN_DOMAIN}${process.env.VUE_APP_GENIE_CTN_CREATE}`;
    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.CTN][Enum.ACCOUNT.CHECK.ACTION_TYPE.FIND_ID] = `${process.env.VUE_APP_GENIE_CTN_DOMAIN}${process.env.VUE_APP_GENIE_CTN_FIND_ID}`;
    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.CTN][Enum.ACCOUNT.CHECK.ACTION_TYPE.FIND_PW] = `${process.env.VUE_APP_GENIE_CTN_DOMAIN}${process.env.VUE_APP_GENIE_CTN_FIND_PW}`;

    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.GIGA][Enum.ACCOUNT.CHECK.ACTION_TYPE.CREATE] = `${process.env.VUE_APP_GENIE_GIGA_DOMAIN}${process.env.VUE_APP_GENIE_GIGA_CREATE}`;
    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.GIGA][Enum.ACCOUNT.CHECK.ACTION_TYPE.FIND_ID] = `${process.env.VUE_APP_GENIE_GIGA_DOMAIN}${process.env.VUE_APP_GENIE_GIGA_FIND_ID}`;
    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.GIGA][Enum.ACCOUNT.CHECK.ACTION_TYPE.FIND_PW] = `${process.env.VUE_APP_GENIE_GIGA_DOMAIN}${process.env.VUE_APP_GENIE_GIGA_FIND_PW}`;

    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.GIGA_CTN][Enum.ACCOUNT.CHECK.ACTION_TYPE.CREATE] = `${process.env.VUE_APP_GENIE_GIGA_CTN_DOMAIN}${process.env.VUE_APP_GENIE_GIGA_CTN_CREATE}`;
    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.GIGA_CTN][Enum.ACCOUNT.CHECK.ACTION_TYPE.FIND_ID] = `${process.env.VUE_APP_GENIE_GIGA_CTN_DOMAIN}${process.env.VUE_APP_GENIE_GIGA_CTN_FIND_ID}`;
    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.GIGA_CTN][Enum.ACCOUNT.CHECK.ACTION_TYPE.FIND_PW] = `${process.env.VUE_APP_GENIE_GIGA_CTN_DOMAIN}${process.env.VUE_APP_GENIE_GIGA_CTN_FIND_PW}`;

    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.OPEN_API][Enum.ACCOUNT.CHECK.ACTION_TYPE.CREATE] = `${process.env.VUE_APP_GENIE_OPEN_API_DOMAIN}${process.env.VUE_APP_GENIE_OPEN_API_CREATE}`;
    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.OPEN_API][Enum.ACCOUNT.CHECK.ACTION_TYPE.FIND_ID] = `${process.env.VUE_APP_GENIE_OPEN_API_DOMAIN}${process.env.VUE_APP_GENIE_OPEN_API_FIND_ID}`;
    check[Enum.ACCOUNT.CHECK.TARGET_TYPE.OPEN_API][Enum.ACCOUNT.CHECK.ACTION_TYPE.FIND_PW] = `${process.env.VUE_APP_GENIE_OPEN_API_DOMAIN}${process.env.VUE_APP_GENIE_OPEN_API_FIND_PW}`;

    return check;
  }
}
